module.exports = __webpack_public_path__ + "static/img/kapasitas-starx.351da9f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/services/kapasitas-starx.png
// module id = ZUbk
// module chunks = 1